import { Injectable } from '@angular/core';

@Injectable({
	providedIn: 'root',
})
export class MonacoService {
	private _schemas: { [p: string]: any } = {};
	private _model: { [p: string]: any } = {};

	addJsonSchema(uri: string, schema: any) {
		const monaco = (window as any).monaco;

		if (!monaco || this._schemas[uri]) {
			return this._model[uri];
		}

		const uris = monaco.Uri.parse(uri);
		this._schemas[uri] = schema;
		this._model[uri] = monaco.editor.createModel('', 'json', uris);

		monaco.languages.json.jsonDefaults.setDiagnosticsOptions({
			validate: true,
			schemas: Object.keys(this._schemas).map((schemaUri) => ({
				uri: schemaUri,
				fileMatch: [this._model[schemaUri].uri.toString()],
				schema: this._schemas[schemaUri],
			})),
		});

		return this._model[uri];
	}

	removeJsonSchema(uri: string): void {
		const monaco = (window as any).monaco;
		if (!monaco) {
			return;
		}

		const model = this._model[uri];
		if (model && !model.isDisposed?.()) {
			try {
				model.dispose();
			} catch {
				// no-op: disposal errors can be safely ignored
			}
		}

		delete this._model[uri];
		delete this._schemas[uri];

		monaco.languages.json.jsonDefaults.setDiagnosticsOptions({
			validate: true,
			schemas: Object.keys(this._schemas).map((schemaUri) => ({
				uri: schemaUri,
				fileMatch: this._model[schemaUri] ? [this._model[schemaUri].uri.toString()] : [],
				schema: this._schemas[schemaUri],
			})),
		});
	}
}
